
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqhrqExWdCPPCDzHtnYjxpOWEz39pFXWX58CqSWfJTpmYMeta } from "/codebuild/output/src3570682819/src/src/pages/faq.vue?macro=true";
import { default as menuJas7n9JX99WT760b4ZzAEJsiw6L_45oUXeqp6eM7dhJowMeta } from "/codebuild/output/src3570682819/src/src/pages/menu.vue?macro=true";
import { default as indexsZZo6fknWYFIDxNZQRjhUqS9gY7u19w68eniCuWoK4cMeta } from "/codebuild/output/src3570682819/src/src/pages/index.vue?macro=true";
import { default as contactMo6AibEGdx9qwKJuFcI2HTPu326g0xRcZStK7p9YyYwMeta } from "/codebuild/output/src3570682819/src/src/pages/contact.vue?macro=true";
import { default as tutorial0qiMDo_6ECtKRkKMIGDRjG4QCXNipC6ITxAb7365DrkMeta } from "/codebuild/output/src3570682819/src/src/pages/tutorial.vue?macro=true";
import { default as agreementLeJRCBU4qXNhlsc0chdF_CMowOyatz0JwHSZcToPZqsMeta } from "/codebuild/output/src3570682819/src/src/pages/agreement.vue?macro=true";
import { default as about_45passl9CXeIUaMP0ahaxFlm8M7AVcb_45ByFiZPYWUKKWC4rQAMeta } from "/codebuild/output/src3570682819/src/src/pages/about-pass.vue?macro=true";
import { default as index5OjMel2qhAB6Aayfvm_RJgy_454H0T6FC3XV4TjHQw7eQMeta } from "/codebuild/output/src3570682819/src/src/pages/card/index.vue?macro=true";
import { default as _91id_937_45kSp9SlW7eYPwgwNR7Iyb0HaWkLzAjc9hhFRbbsCHwMeta } from "/codebuild/output/src3570682819/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancebfNiRVhDdUUQyD7wzT2cHjW5baGGskkL8nFwVSw1tq4Meta } from "/codebuild/output/src3570682819/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93aX3uITUBLNSRs4_UbLLVlH1SHBF_NRgYE6R65vP_Q_cMeta } from "/codebuild/output/src3570682819/src/src/pages/notice/[id].vue?macro=true";
import { default as indextL8sHmFC_AqtNGDhb1wWnIN8YzXMk33oHu_h6uD3OwoMeta } from "/codebuild/output/src3570682819/src/src/pages/coupon/index.vue?macro=true";
import { default as index1KwwpCAZ4jy8beqbaFdPmesURRN_yvbPTZBXC4Xixs4Meta } from "/codebuild/output/src3570682819/src/src/pages/mypage/index.vue?macro=true";
import { default as index_45lGPlshXndrug40GM3u7RWCvgAcOt0uho58GhCF8gYMMeta } from "/codebuild/output/src3570682819/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_938eqbskIB5oBH8GfCnT4qZ_451OQnR9ref9iemYOWfOfjEMeta } from "/codebuild/output/src3570682819/src/src/pages/parking/[id].vue?macro=true";
import { default as indexfmeP5g0YgsgIImIZZIuNo1Ba26zKi_45c1pCt7_oCXO3YMeta } from "/codebuild/output/src3570682819/src/src/pages/history/index.vue?macro=true";
import { default as index0rLmHYOdoME7cnx_P1O3UONPQiAYaYUxo6_llY5KCZ8Meta } from "/codebuild/output/src3570682819/src/src/pages/monthly/index.vue?macro=true";
import { default as indexrV2yINhn5gu4VsswzINO992u2gJxp60SuqB5u_45__45LusMeta } from "/codebuild/output/src3570682819/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexIBaLR4leH0uiMsD2dJu_1NjcjwlpPsLJZ5XXQakEG5sMeta } from "/codebuild/output/src3570682819/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviZksbsnJjkbKscPVKaV8uZDnLYaRgJcDgO18jHDx28_45UMeta } from "/codebuild/output/src3570682819/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editd3iKBZQPwuTc5Qutqd_45xPAZfCmoSWXBvcGwudy6FCboMeta } from "/codebuild/output/src3570682819/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementCEVNsr_3t1WjMQU_4501OWQRuqveCY7_458EKw4xp2nd5IoMeta } from "/codebuild/output/src3570682819/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexpNW2ds0XDA0QaudebzKkeQHmifi8AdsF28XhWlctmx0Meta } from "/codebuild/output/src3570682819/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dSc5pFvtMt_45O8UH56bFelD0wZbK4_Mj4WGTbOvNvNkd0Meta } from "/codebuild/output/src3570682819/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmnysITdijlv2G9Y7fpG42H_nKfYRd6yxUQJqLWTl3_45yQMeta } from "/codebuild/output/src3570682819/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexFbkXv_45Ir6MxtFnmkSXBaZJ5aQGmg1F0mEfY_45tcyK7boMeta } from "/codebuild/output/src3570682819/src/src/pages/card/create/index.vue?macro=true";
import { default as index5pPba0ENIdzvJ6pHrtgPwHUxAJfvaXVKIyDzv7f14tQMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmgTjdoXeX7xY_45sOS9YoTYEQDPoIcBpWmBQdTYIaZ36VkMeta } from "/codebuild/output/src3570682819/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmJGHGY8b7xeiteG_5dy0gF2Nig3Stt6Rf1kzgPf16RdYMeta } from "/codebuild/output/src3570682819/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeCQPU8_451gktIEqVrn3hIoii4hE3X7ilY65Prq5DP1TFIMeta } from "/codebuild/output/src3570682819/src/src/pages/membership/complete.vue?macro=true";
import { default as registerL7qpEjpLOTE3VnN6o4dRInkYzfM8whpV9pHCQnISt3YMeta } from "/codebuild/output/src3570682819/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_939Oi_9qAMHG0dKHgYJ_45LNdnd0x8M5MAI3wcjjrq1qwcwMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmU1k68mDhRVA5DEG5TaQmFnsz28LOEcz__45d4e0GlCbTQMeta } from "/codebuild/output/src3570682819/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_931ff964uikIprlqiP3tBxrFV13_HH96zqDLktVUEnhCcMeta } from "/codebuild/output/src3570682819/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexaZyep3ZtW_Wxa_45550Fq8Pxk8MJQUyDes6czxHF6c11YMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeeuLw4MQRtnQDf1gxjN5BNZkXrMsjCFiHis044CB1IMwMeta } from "/codebuild/output/src3570682819/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeHX2wl1nc0EUAJkULkv7l_qffKPst7G9ZwT0wMWdT7egMeta } from "/codebuild/output/src3570682819/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeruCW4gI4a2IOEgYwvbCmfsIW97eRY58at_rv2_GBywcMeta } from "/codebuild/output/src3570682819/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerRGnuw2Qrii7ijn3OArV7_45DePQhEIcyTUewggm9tXt2oMeta } from "/codebuild/output/src3570682819/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete2Q4LeS43ATEXOQKZIRlgf0g50BtyZqB5puVOjb9x8D4Meta } from "/codebuild/output/src3570682819/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexVkNC9F1GMtLftrdG1wglCS6_45At_ZWYP_hBL9bbDbnqEMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmD_45k4gM_5Ley_45TLx1UM8tbB13LtqpFlpj_45za3imTMMOEMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeTUNA0j2eN8quW6ZkYwyezMUv5vtKdNdWHh6h5lC8Y7kMeta } from "/codebuild/output/src3570682819/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexAbJZIzTrlwirfBRtMQQzzTQinAo04BWpYksCE5UjjV8Meta } from "/codebuild/output/src3570682819/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93CHmLk4_45s3P1h5GYHcV6mTkfQAg27rYgmNOf8h2j2u_45AMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeUuxz4Z1li7e5U7TH1NHvi4ABRbcUqPKfxFyRmufqxxIMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliaso39tjgtoKgrU9REWSJ9PoQr6Q5jJctkAI5ioojz_45uRYMeta } from "/codebuild/output/src3570682819/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleJP22lY2MBfo_uiOsDRa2V7k_ezhSRQvCcxyFLX9MYakMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailAddOiAqeMsonsWa_45It6Aqu6bn2VBsX5WikASNNLLzFQMeta } from "/codebuild/output/src3570682819/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmVd7821JXcWtSLRLyAvn19r41aP0an8qFgzREzkkyjEUMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentquE6WbSYykdQsCuwdkLD3T___45DYJlQPhobrAUfwvxj0Meta } from "/codebuild/output/src3570682819/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm5l5lTP0aYYCa9bDfNZPV1L8zZl8P_45NYjLY5i79WvM68Meta } from "/codebuild/output/src3570682819/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedaterslXIM3ufiZFcDPug9_454BkV2Ze5O0H9czm7WP3g8QdcMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completejDaip_451vH_lTYryGRXD_YCGniEFZEjhCRrAIYIZugBAMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codekqlpUBMWanXhFh9nijfROmxgpx2_ZMZ9ZCQBQhp944AMeta } from "/codebuild/output/src3570682819/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordMELUqj0r7W0UdnkN1NyGHTqMLsZc_Nj9B_45NKIo3JOfYMeta } from "/codebuild/output/src3570682819/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasPujJ5miouTO4omYN91ie0nGdDPecUWVUfKt41eEeH_8Meta } from "/codebuild/output/src3570682819/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerZNYphAp_vyCBBafCFVq2Kb7AVurv6HCmy3850V2iqcgMeta } from "/codebuild/output/src3570682819/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45coded2xHAEUe6jD751hucyRN0L17vifiiiy543L7ZU8_SNIMeta } from "/codebuild/output/src3570682819/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index8f3EjHozeoRFNDjpjQuhHM4tsJBFKo6u0neb6A5SM5cMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexAErFGkWFCb7jnbMUNtOMhAcm24FoK3_vi4SeXgOd75EMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexH6TC3aYJMxciWa11HIakX2ewLXE_45XifA_45MZec1CWUvoMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexfrYD0wusQczbDxzTHo2sODU3ANXu6Vd015IFKoCbl8wMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatezQSo3BcejpaytUPPFXfCi2BOLl59v4kpck2wFB_YcI4Meta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeOPaaaYFTA0ulfr3Hl_tBIu_45jNT2PRzcB5oS6tg1SXCUMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmm9kDukJlcWuqg8QZ28LL_w1KQ2022GXpWb5_8Y4m8WEMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexoz31jS0Pj0C1JVkD8_45nfRjkE3jKk_45VykdBiOjC53sw4Meta } from "/codebuild/output/src3570682819/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete_c9NgIDXUenh9fHBD_45GK5BdnqfVBkNfTdo3k2ZPAU4YMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatejI6zFPq_45aDmjSj5U3CIpW9lAGnpH_IKCHBHrfmBd8usMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexX89OnVLW68EGjzLkLIfJ1UG_45FFm9XSxschF3ZX0zJYIMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexogJLkIra7FNPK_45qcE83UEOWsjf_456gmwk_45YpyP42RUi4Meta } from "/codebuild/output/src3570682819/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeY7_45Hn_45JrC8L9rWnbtslfUZ0Qnrmkf_45Rmn8AApJaEsN0Meta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexteEmlLly07lDlmDss_459Sz79lim4FRfkxdZPznq95vqQMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeoN4Bl0rO_lyNDcfTHQ7QJ9WA2C0vGMjHnVYqsn8pN1IMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index0gNCVTppCbsRxW5QmOxIG8PTvyTywRedcs0JOJDiRyMMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexnxVZbzOcVxWiKGOtZq5tuskBP0oZXjfSK44m6nqaHdQMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexgx1sKvzHyblbj5m2Gm4pgdfbLZk9c3e8Wq_45JqYfV6AoMeta } from "/codebuild/output/src3570682819/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateCYYjWMAhqvzhR7vZZNCRnrcqPuvtjdf0Y9BMrYdGf7gMeta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm4Mzhg6Qtd7d3IFri_45JrXpxu_45VyG2NkdlXFwAaHQdK_454Meta } from "/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuJas7n9JX99WT760b4ZzAEJsiw6L_45oUXeqp6eM7dhJowMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexsZZo6fknWYFIDxNZQRjhUqS9gY7u19w68eniCuWoK4cMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indextL8sHmFC_AqtNGDhb1wWnIN8YzXMk33oHu_h6uD3OwoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexfmeP5g0YgsgIImIZZIuNo1Ba26zKi_45c1pCt7_oCXO3YMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexrV2yINhn5gu4VsswzINO992u2gJxp60SuqB5u_45__45LusMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexIBaLR4leH0uiMsD2dJu_1NjcjwlpPsLJZ5XXQakEG5sMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexFbkXv_45Ir6MxtFnmkSXBaZJ5aQGmg1F0mEfY_45tcyK7boMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmgTjdoXeX7xY_45sOS9YoTYEQDPoIcBpWmBQdTYIaZ36VkMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmJGHGY8b7xeiteG_5dy0gF2Nig3Stt6Rf1kzgPf16RdYMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeCQPU8_451gktIEqVrn3hIoii4hE3X7ilY65Prq5DP1TFIMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerL7qpEjpLOTE3VnN6o4dRInkYzfM8whpV9pHCQnISt3YMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmU1k68mDhRVA5DEG5TaQmFnsz28LOEcz__45d4e0GlCbTQMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeeuLw4MQRtnQDf1gxjN5BNZkXrMsjCFiHis044CB1IMwMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeHX2wl1nc0EUAJkULkv7l_qffKPst7G9ZwT0wMWdT7egMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeruCW4gI4a2IOEgYwvbCmfsIW97eRY58at_rv2_GBywcMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerRGnuw2Qrii7ijn3OArV7_45DePQhEIcyTUewggm9tXt2oMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmD_45k4gM_5Ley_45TLx1UM8tbB13LtqpFlpj_45za3imTMMOEMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeTUNA0j2eN8quW6ZkYwyezMUv5vtKdNdWHh6h5lC8Y7kMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexAbJZIzTrlwirfBRtMQQzzTQinAo04BWpYksCE5UjjV8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeUuxz4Z1li7e5U7TH1NHvi4ABRbcUqPKfxFyRmufqxxIMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleJP22lY2MBfo_uiOsDRa2V7k_ezhSRQvCcxyFLX9MYakMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailAddOiAqeMsonsWa_45It6Aqu6bn2VBsX5WikASNNLLzFQMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmVd7821JXcWtSLRLyAvn19r41aP0an8qFgzREzkkyjEUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentquE6WbSYykdQsCuwdkLD3T___45DYJlQPhobrAUfwvxj0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm5l5lTP0aYYCa9bDfNZPV1L8zZl8P_45NYjLY5i79WvM68Meta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completejDaip_451vH_lTYryGRXD_YCGniEFZEjhCRrAIYIZugBAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codekqlpUBMWanXhFh9nijfROmxgpx2_ZMZ9ZCQBQhp944AMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordMELUqj0r7W0UdnkN1NyGHTqMLsZc_Nj9B_45NKIo3JOfYMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerZNYphAp_vyCBBafCFVq2Kb7AVurv6HCmy3850V2iqcgMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45coded2xHAEUe6jD751hucyRN0L17vifiiiy543L7ZU8_SNIMeta || {},
    component: () => import("/codebuild/output/src3570682819/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3570682819/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]